import React from "react";
import { Container, Row, Col, Card, CardHeader, CardBody } from "shards-react";

import PageTitle from "../components/common/PageTitle";
import SetScreenOverview from "../components/archive/setScreenOverview";


const SetOverview = (props) => (
  <Container fluid className="main-content-container px-4">
    {/* Page Header */}
    <Row noGutters className="page-header py-4">
      <PageTitle sm="4" title="Archief - Overzicht - Sets" subtitle="Q-sort" className="text-sm-left" />
    </Row>

    {/* Default Light Table */}
    <Row>
      <Col lg="10">
          <SetScreenOverview urllink={props.match.params.catname} setname={props.match.params.setname} categorykey={props.match.params.categorykey} setkey={props.match.params.setkey}/>
       
      </Col>
    </Row>
  </Container>
);

export default SetOverview;
